import * as frappeSDK from "frappe-react-sdk";
const _f = (frappeSDK as any).default || frappeSDK;
const { useFrappeGetCall } = _f as Pick<typeof frappeSDK, "useFrappeGetCall">;

export interface DepartmentListItem {
  name: string;
  department: string;
  icon: string;
  tagline: string;
  description: string;
}

export interface DepartmentServiceItem {
  title: string;
  desc: string;
}

export interface DepartmentFacilityItem {
  title: string;
  desc: string;
}

export interface DepartmentStatItem {
  value: string;
  label: string;
}

export interface DepartmentFAQItem {
  q: string;
  a: string;
}

export interface DepartmentDetail {
  name: string;
  department: string;
  icon: string;
  tagline: string;
  description: string;
  about: string[];
  specialties: string[];
  services: DepartmentServiceItem[];
  facilities: DepartmentFacilityItem[];
  stats: DepartmentStatItem[];
  faqs: DepartmentFAQItem[];
}

export const useDepartments = () => {
  const { data, isLoading, error } = useFrappeGetCall<{ message: DepartmentListItem[] }>(
    "health_web.api.departments.get_departments",
    undefined,
    "medical_departments",
  );

  return {
    departments: data?.message ?? [],
    isLoading,
    error,
  };
};

export const useDepartment = (name: string | undefined) => {
  const { data, isLoading, error } = useFrappeGetCall<{ message: DepartmentDetail }>(
    "health_web.api.departments.get_department",
    name ? { name } : undefined,
    name ? `medical_department_${name}` : undefined,
  );

  return {
    department: data?.message ?? "",
    isLoading,
    error,
  };
};
